exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-tree[data-v-96fae4dc]::-webkit-scrollbar{width:6px}.options-tree[data-v-96fae4dc]  .el-tree-node__content{height:36px}", ""]);

// exports
